import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import { MOCK_DATA, APP_CONFIG } from "../../constants";
import HomeIcon from "../../assets/icons/home.svg";
import HumanIcon from "../../assets/icons/human.svg";
import "./VitalsCheck.css";
import HumanScanVideo from "../../assets/videos/human_scan.mp4";
import Header from "../shared/Header";
import arrow from "../../assets/icons/arrow.svg";

const VitalsCheck = ({ userData }) => {
  const navigate = useNavigate();
  const { t, isRTL } = useLocalization();
  const [isMeasuring, setIsMeasuring] = useState(false);
  const [isSitting, setIsSitting] = useState(false);
  const [measures, setMeasures] = useState([]);

  // Mapping function to localize vital names
  const getLocalizedVitalName = (englishName) => {
    const vitalMap = {
      "Muscle Mass": t("vitalsCheck.vitals.muscleMass"),
      Weight: t("vitalsCheck.vitals.weight"),
      "Bone Mass": t("vitalsCheck.vitals.boneMass"),
      "Heart pulse": t("vitalsCheck.vitals.heartPulse"),
      "Fat percentage": t("vitalsCheck.vitals.fatPercentage"),
      "Blood pressure": t("vitalsCheck.vitals.bloodPressure"),
      BMI: t("vitalsCheck.vitals.bmi"),
      "Metabolic Age": t("vitalsCheck.vitals.metabolicAge"),
      "Nerve Health": t("vitalsCheck.vitals.nerveHealth"),
      "Fat Ratio": t("vitalsCheck.vitals.fatRatio"),
      Hydration: t("vitalsCheck.vitals.hydration"),
    };
    return vitalMap[englishName] || englishName;
  };

  useEffect(() => {
    setIsMeasuring(true);
    setTimeout(() => {
      setIsMeasuring(false);
      setMeasures(MOCK_DATA.VITALS.standing);
    }, 5000);
  }, [t]); // Re-run when language changes

  return (
    <div className="main-container">
      <Header text={t("vitalsCheck.title")} userData={userData} />
      {isMeasuring ? (
        <>
          {/* Video Background for measuring phase */}
          <video className="video-background" autoPlay loop muted playsInline>
            <source src={HumanScanVideo} type="video/mp4" />
          </video>
          <div className="description-container" style={{ margin: "5% 7%" }}>
            {t("vitalsCheck.instructions")}
          </div>
        </>
      ) : (
        <>
          {/* Results phase with human.svg background */}
          <div className="results-container">
            <div className="human-background">
              <img
                src={HumanIcon}
                alt="Human body scan"
                className="human-svg"
              />
            </div>

            <div className="vitals-grid">
              {measures.map((vital, index) => (
                <div key={index} className="vital-card">
                  <div className="corner-top-right"></div>
                  <div className="corner-bottom-left"></div>
                  <div className="vital-card-header">
                    <div className="vital-name">
                      {getLocalizedVitalName(vital.name)}
                    </div>
                    <div className="vital-icon">
                      <img
                        src={vital.icon}
                        alt={getLocalizedVitalName(vital.name)}
                      />
                    </div>
                  </div>
                  <div className="vital-value-container">
                    <div className="vital-value">{vital.value}</div>
                    <div className="vital-unit">{vital.unit}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      <div className="assessment-footer">
        <button
          className="footer-btn home-btn"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
          onClick={() => navigate("/dashboard")}
        >
          <img src={HomeIcon} alt="Home" />
        </button>
        {!isMeasuring && (
          <div className="footer-btn-container">
            <button
              className="next-btn talk-to-doctor-btn"
              style={{
                whiteSpace: "nowrap",
                padding: "6% 15%",
                color: "rgb(192 168 245)",
              }}
              onClick={() => navigate("/assessment")}
            >
              <span>{t("vitalsCheck.proceedToAssessments")}</span>
              <img
                src={arrow}
                alt="Next"
                style={{
                  marginTop: 2,
                  marginLeft: 3,
                  filter:
                    "brightness(0) saturate(100%) invert(75%) sepia(20%) saturate(200%) hue-rotate(250deg) brightness(120%) contrast(100%)",
                  transform: isRTL ? "rotate(180deg)" : "none",
                  transition: "transform 0.3s ease",
                }}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VitalsCheck;
